import { gql } from '@apollo/client';

import { GET_ACCOUNT_OPERATION, GET_ADDRESSES_OPERATION } from 'utils/constants';

export const GET_ACCOUNT = gql`
  query ${GET_ACCOUNT_OPERATION}($accountId: ID!, $endCustomerAccountId: ID!) {
    getAccount(accountId: $accountId) {
      accountId
      commerceComplete
      defaultCurrencyCode
      currencyConversionRate
      getDefaultBillToAddress(accountId: $endCustomerAccountId) {
        country
      }
    }
  }
`;

export const GET_ADDRESSES = gql`
  query ${GET_ADDRESSES_OPERATION}($accountId: ID!) {
    getAccount(accountId: $accountId) {
      accountId
      getAddresses {
        addressId
        type
        favorite
        address {
          address1
          address2
          city
          state
          zipcode
          country
        }
      }
    }
  }
`;
